<template>
    <div>
        <v-layout>
            <v-flex xs12 sm12 md12 lg9 xl9 style="padding-top: 5px;padding-left: 18px;margin:auto">
                <div id="memberList">
                    <v-layout class="reportPanel">
                        <v-flex xs4 sm4 md4 lg4 xl4 style="text-align: center;">
                            <div class="label">
                                ĐIỂM TRUNG BÌNH
                            </div>
                            <div class="content" style="font-size: 50px;font-weight: bold;text-align: center;margin-top: 10px">
                                {{averateMark}}
                            </div>
                        </v-flex>
                        <v-flex xs8 sm8 md8 lg8 xl8>
                            <canvas id="mark-lesson-report-chart-detail"/>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-data-table :headers="exerciseReportHeaders" class="elevation-1"
                                          :items="exerciseReport" hide-actions locale="vi">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">{{ props.index+1}}</td>
                                    <td class="text-xs-left">{{ props.item["userName"] }}</td>
                                    <td class="text-xs-right">
                                        <div v-if="editReport==false">
                                            {{ props.item["mark"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text" style="text-align: right"
                                               v-model='props.item["mark"]'/>

                                    </td>
                                    <td class="text-xs-right">{{ props.item["rank"]}}</td>
                                    <td class="text-xs-left">
                                        <div v-if="editReport==false">
                                            {{ props.item["teacherComment"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text"
                                               list="commentSuggest"
                                               v-model='props.item["teacherComment"]'/>
                                    </td>
                                    <td class="text-xs-left">
                                        <div v-if="editReport==false">
                                            {{ props.item["teacherCommentImprove"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text"
                                               list="attitudeCommentSuggest"
                                               v-model='props.item["teacherCommentImprove"]'/>
                                    </td>
                                </template>
                            </v-data-table>
                            <datalist id="commentSuggest">
                                <option value="Tốt"/>
                                <option value="Rất tốt"/>
                            </datalist>
                            <datalist id="attitudeCommentSuggest">
                                <option value="Rất nghiêm túc"/>
                                <option value="Nghiêm túc"/>
                                <option value="Thiếu tích cực"/>
                            </datalist>

                        </v-flex>
                    </v-layout>
                    <div style="text-align: right">
                        <v-btn color="primary" @click="onExportReport">
                            {{$t('lang.common.exportReport') }}
                        </v-btn>
<!--
                        <v-btn class="orange" dark @click="onSendEmail">
                            {{$t('lang.common.sendEmail')}}
                        </v-btn>
-->
                        <v-btn class="blue" dark @click="onSend" v-if="!editReport">
                            {{$t('lang.class.send')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="editReport = true" v-if="!editReport">
                            {{$t('lang.common.edit')}}
                        </v-btn>
                        <v-btn @click="saveReport()" v-if="editReport"
                               class="yoprimary" dark>
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn @click="closeDetail()" color="red" dark>
                            {{$t('lang.common.back')}}
                        </v-btn>
                    </div>
                </div>
                <send-to-member :class-id="classId" :exercise-id="exerciseId" :exerciseType="exerciseType" @send="onChangeReceiver" ref="sendDialog" :selectable="false"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import SendToMember from "../sendToMember";

    export default {
        name: "lesson-report-item",
        components: {SendToMember},
        props: {
            classId: {
                type: String | Number,
                default: null
            },
            exerciseId: {
                type: String | Number,
                default: null
            },
            exerciseType: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            display: "report",
            editReport: false,
            month: "",
            reportHeaders: [
                {
                    text: "STT",
                    align: "left",
                    sortable: false,
                    value: "index"
                },
                {
                    text: "Loại báo cáo",
                    align: "left",
                    sortable: false,
                    value: "reportType"
                },
                {
                    text: "Tên báo cáo",
                    align: "left",
                    sortable: false,
                    value: "reportName"
                },
                {
                    text: "Thời gian cập nhật",
                    align: "left",
                    sortable: false,
                    value: "reportDate"
                },
                {
                    text: "Trạng thái",
                    align: "left",
                    sortable: false,
                    value: "status"
                },
                {
                    text: "Xử lý",
                    align: "left",
                    sortable: false,
                    value: "status"
                }
            ],
            studentHeaders: [
                {
                    text: "Sinh viên",
                    align: "left",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {text: "Báo cáo chi tiết", value: "name", align: "center", sortable: false}
            ],
            students: [],
            exerciseReportHeaders: [
                {
                    text: "STT",
                    align: "left",
                    sortable: false,
                    value: "index"
                },
                {
                    text: "Họ Tên",
                    align: "left",
                    sortable: false,
                    value: "question"
                },
                {
                    text: "Điểm",
                    align: "right",
                    sortable: false,
                    value: "mark"
                },
                {
                    text: "Xếp hạng",
                    align: "right",
                    sortable: false,
                    value: "rank"
                },
                {
                    text: "Nhận xét bài tập",
                    align: "left",
                    sortable: false,
                    value: "teacherComment"
                },
                {
                    text: "Nhận xét thái độ học tập",
                    align: "left",
                    sortable: false,
                    value: "teacherCommentImprove"
                }
            ],
            exerciseReport: [],
            workingReport: null,
            averateMark: null,
        }),

        computed: {},

        watch: {
            classId: function (data) {
                this.getReport();
            },
            exerciseId: function (data) {
                this.getReport();
            },
            exerciseType: function (data) {
                this.getReport();
            }
        },

        created() {
            this.getReport();
        },

        methods: {
            getReport(){
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/getLessonReport?classId=" +
                        this.classId +"&exerciseId="+this.exerciseId+"&exerciseType="+this.exerciseType
                    )
                    .then(
                        data => {
                            this.viewReport(data);
                        },
                        error => {
                        }
                    )

            },

            viewReport: function (report) {
                this.editReport = false;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
                this.getListStudentMark();

            },

            updateReport: function (report) {
                this.exerciseId = report.exerciseId;
                this.exerciseType = report.exerciseType;
                this.editReport = true;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
                this.getListStudentMark();
            },

            edit(){
                //console.log("SDFdsfds");
                this.editReport = true;
            },

            getClassMembers: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .get(
                        process.env.VUE_APP_API_URL +
                        "/classmember/myStudents?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.students = data;
                        },
                        error => {
                        }
                    )
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getMarkReportOfExercise?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapMark = data;
                            this.averateMark = data[0];
                            const ctxmark = document.getElementById('mark-lesson-report-chart-detail');
                            const chartmark = new Chart(ctxmark, {
                                type: 'pie',
                                data: {
                                    labels: ["<6.5", "6.5-8", "≥8"],
                                    datasets: [
                                        {
                                            data: [this.mapMark[6], this.mapMark[8], this.mapMark[10]],
                                            backgroundColor: [
                                                '#36a2eb',
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getStudentMark: function (userId) {
                this.display = "detail";
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getStudentMark?classId=" + this.classId + "&userId=" + userId)
                    .then(
                        data => {
                            this.exerciseReport = data;
                            const ctxmark = document.getElementById('member-mark-report-chart');
                            let label = [];
                            let markData = [];
                            let max = 0;
                            for (let i = 0; i < this.exerciseReport.length; i++) {
                                label.push(this.exerciseReport[i].endTime);
                                markData.push(this.exerciseReport[i].mark);
                                if (this.exerciseReport[i].mark > max) {
                                    max = this.exerciseReport[i].mark;
                                }
                            }
                            console.log(label);
                            console.log(markData);
                            console.log(max);
                            const chartmark = new Chart(ctxmark, {
                                type: 'line',
                                data: {
                                    labels: label,
                                    datasets: [
                                        {
                                            label: "Biểu đồ điềm",
                                            borderColor: 'orange',
                                            borderWidth: 1,
                                            data: markData,
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    },
                                    scales: {
                                        yAxes: [{
                                            display: true,
                                            ticks: {
                                                suggestedMin: 0, //min
                                                suggestedMax: max //max
                                            }
                                        }]
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getListStudentMark: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getListStudentMark?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.exerciseReport = data;
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onExportReport: function () {
                let url = process.env.VUE_APP_API_URL + "/exercise/exportWord?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType;
                window.location.href = url;
            },

            saveReport: function () {
                console.log(this.exerciseReport);
                axios.post(process.env.VUE_APP_API_URL + "/exercise/updateStudentMark?", this.exerciseReport)
                    .then(
                        data => {
                            if (data.success) {
                                axios.post(process.env.VUE_APP_API_URL + "/report/saveReport?", this.workingReport).then(
                                    saveResult => {
                                        if (saveResult.success) {
                                            message.success(this.$t('lang.common.save_success'));
                                            this.workingReport = saveResult.ref;
                                            this.editReport = false;
                                            this.getMarkReport();
                                            this.getListStudentMark();
                                        }
                                    },

                                    saveError => {
                                        message.error(saveError);

                                    }
                                );

                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )

            },

            closeDetail: function () {
                //this.display = "report";
                //this.getLessonReportList();
                this.$emit("close");
            },

            onSendSMS: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendLessonSMSReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi SMS thành công");
                            } else {
                                message.error("Gửi SMS không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/sendReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                console.log(url);
                let state = this.classId + "_" + this.exerciseId + "_" + this.exerciseType;
                url = encodeURIComponent(url);
                console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            },

            onSend: function(){
                this.$refs.sendDialog.show();
            },

            onChangeReceiver: function(receivers){
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",this.workingReport).then(
                    data=>{
                        if(data.success){
                            this.onSendEmail();
                            this.onSendSMS();
                            //this.onSendZalo();
                            this.workingReport = data.ref;
                        }
                    }
                )
            },

        }
    };
</script>